import type { SchemaColumn, SchemaField } from '@cli-types/core-engine/schema.js'

export function schemaColumnTypeForField(field: SchemaField): SchemaColumn['type'] | undefined {
  switch (field.type) {
    case 'image':
    case 'media':
    case 'video':
      return 'image'
    case 'date':
    case 'timestamp':
      return 'date'
    case 'number':
    case 'decimal':
      return 'number'
    case 'boolean':
      return 'boolean'
    case 'select':
      return 'badge'
    case 'email':
      return 'email'
    case 'string':
    case 'varchar':
    case 'text':
    case 'markdown':
    case 'richtext':
    case 'time':
    case 'icon':
    case 'relationship':
      return 'text'
    default:
      return undefined
  }
}
